import { rem } from "@mantine/core";
import IconProps from "./types";


const TelegramIcon = ({ size = 24, style, ...others }: IconProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...others}
            style={{ width: rem(size), height: rem(size), ...style }}
        >
            <path d="M10.4995 14.3288L20.9995 3.82879M10.6271 14.6569L13.2552 21.4149C13.4867 22.0102 13.6025 22.3079 13.7693 22.3948C13.9139 22.4701 14.0862 22.4702 14.2308 22.3951C14.3977 22.3083 14.5139 22.0108 14.7461 21.4157L21.3364 4.52798C21.5461 3.9908 21.6509 3.72221 21.5935 3.55059C21.5437 3.40154 21.4268 3.28457 21.2777 3.23478C21.1061 3.17744 20.8375 3.28226 20.3003 3.49189L3.41258 10.0822C2.8175 10.3145 2.51997 10.4306 2.43326 10.5975C2.35809 10.7422 2.35819 10.9144 2.43353 11.059C2.52043 11.2258 2.81811 11.3416 3.41345 11.5731L10.1715 14.2012C10.2923 14.2482 10.3527 14.2717 10.4036 14.308C10.4487 14.3402 10.4881 14.3796 10.5203 14.4247C10.5566 14.4756 10.5801 14.536 10.6271 14.6569Z" stroke={others.color ?? "#CCD6EC"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default TelegramIcon